import json from './plzlist.json'
export const plzOptions = json.map(a => ({
    label: `${a[0]} ${a[1]}`,
    value: <string>a[0]
})).sort((a,b) => parseInt(a.value)-parseInt(b.value))
export const plzMap: {[plz: string]: {name:string, plz: string, lat:number, lon:number}} = {}

for(let p of json) {
    plzMap[p[0]] = {
        plz: p[0].toString(),
        name: p[1].toString(),
        lat: <number>p[2],
        lon: <number>p[3]
    }
}

// Converts numeric degrees to radians
function toRad(Value: number) 
{
    return Value * Math.PI / 180;
}

//This function takes in latitude and longitude of two location and returns the distance between them as the crow flies (in km)
function calcCrow(lat1: number, lon1: number, lat2: number, lon2: number): number
{
    var R = 6371; // km
    var dLat = toRad(lat2-lat1);
    var dLon = toRad(lon2-lon1);
    var lat1 = toRad(lat1);
    var lat2 = toRad(lat2);

    var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2); 
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
    var d = R * c;
    return d;
}

export function plzDistance(plz1: string, plz2: string): number {
    const p1 = plzMap[plz1]
    const p2 = plzMap[plz2]
    if(!p1 || !p2) return Infinity

    return calcCrow(p1.lat, p1.lon, p2.lat, p2.lon)
}